import { useTranslation } from 'react-i18next'

export function useValidation() {
  const { t } = useTranslation(['global', 'validation'])

  function fieldEmpty(value?: string) {
    if (!value || value.trim() === '') {
      return true
    }
  }

  function emailError(email: string, mandatory: boolean) {
    if (email.trim() === '') {
      return mandatory
    } else {
      // eslint-disable-next-line
      const regex = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      const isValid = regex.test(email)

      if (!isValid) {
        return t('validation:invalid_email')
      }
    }

    return false
  }

  function phoneNumberError(phone: string, mandatory: boolean) {
    if (phone.trim() === '') {
      return mandatory
    } else {
      // eslint-disable-next-line
      const regex = /^(?:(?:\(?(?:00|\+)([1-4]\d\d|[1-9]\d?)\)?)?[\-\.\ \\\/]?)?((?:\(?\d{1,}\)?[\-\.\ \\\/]?){0,})(?:[\-\.\ \\\/]?(?:#|ext\.?|extension|x)[\-\.\ \\\/]?(\d+))?$/i
      const isValid = regex.test(phone)

      if (!isValid) {
        return t('validation:invalid_phone')
      }
    }

    return false
  }

  return {
    fieldEmpty,
    emailError,
    phoneNumberError
  }
}
